import { render, staticRenderFns } from "./DiagnosisSuggestInput.vue?vue&type=template&id=40bd3562"
import script from "./DiagnosisSuggestInput.vue?vue&type=script&lang=js"
export * from "./DiagnosisSuggestInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports